<template>
   <div
      class="text"
      v-bind="$props"
      :class="classes"
      >
      <slot></slot>{{text}}
   </div>
</template>

<script>
export default {
   name: 'AtomText',
   props: {
      text: {
         type: String,
      },
      size: {
         type: String,
         default: "medium",
         validator: value => ["x-large", "large", "medium", "small", "x-small"].includes(value),
      },
      color: {
         type: String,
         default: "secondary",
         validator: value => ["primary","secondary","success","info","light","dark", "danger"].includes(value),
      }
   },
   computed: {
      classes() {
         return [ this.color, this.size ];
      },
   }
}
</script>

<style lang="scss" scoped>
@mixin setSize($size, $margin)
{
   font-size: $size;
   margin: $margin;
}

$darken-percent: 10%;

.text {
   color: $font-color;
   font-family: $primary-font;
   font-size: 14px;
   margin: 10px 0px;
   display: block;
   border-radius: $border-radius;

   &.x-small { @include setSize(11.5px, 4px 2px); }
   &.small { @include setSize(12.5px, 6px 3px); }
   &.large { @include setSize(16px, 10px 5px); }
   &.x-large { @include setSize(24px, 18px 9px); }

   &.primary { color: $primary-color; }
   &.secondary { color: $font-color; }
   &.success { color: darken($success-color, $darken-percent); }
   &.info { color: $info-color; }
   &.light { color: $light-color; }
   &.dark { color: $dark-color; }
   &.danger { color: darken($danger-color, $darken-percent); }
}
</style>